import { createORPCClient } from "@orpc/client";
import type { ContractRouterClient } from "@orpc/contract";
import { OpenAPILink } from "@orpc/openapi-client/fetch";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";
import { apiFetch } from "@packages/core-client/api/apiFetch.ts";
import { queryPath } from "@packages/core-client/query/queryKeys.ts";
import { useEnvironmentVariable } from "@squide/firefly";
import { useMemo } from "react";
import { directoryContract } from "#shared/directoryContract.ts";

function createDirectoryClient(baseUrl: string) {
    const link = new OpenAPILink(directoryContract, {
        url: `${baseUrl}/api/people/directory`,
        fetch: apiFetch
    });

    const client: ContractRouterClient<typeof directoryContract> = createORPCClient(link);
    const queryUtils = createTanstackQueryUtils(client, { path: queryPath("people", ["members"]) });

    return { client, queryUtils };
}

export function useDirectoryClient() {
    const apiBaseUrl = useEnvironmentVariable("apiBaseUrl");

    return useMemo(() => createDirectoryClient(apiBaseUrl), [apiBaseUrl]);
}
